import api, { GETTING_STARTED_TYPE, LIST } from '../Api';
import { IActionResponse } from '../../dal/BaseDAL';
import {
    IGettingStartedResponse,
    IGettingStartedStepStatusRequest
} from '../../models/GettingStarted';

// Onboarding checklist ("Getting Started").
//
// The whole checklist is one small document scoped to the selected organization, so there is a
// single list tag rather than per-step tags. The step status mutation invalidates it, which also
// re-runs the server-side completion rules (a step can unlock others through its prerequisites).
//
// The GET is polled from the nav bar. It is deliberately tolerant of a 404: the button hides itself
// when the query errors, so an environment where the endpoint is not deployed yet simply shows no
// checklist rather than breaking the command bar.
const gettingStartedApi = api.injectEndpoints({
    endpoints: (build) => ({
        getGettingStarted: build.query<IGettingStartedResponse, void>({
            query: () => 'settings/gettingstarted',
            providesTags: [{ type: GETTING_STARTED_TYPE, id: LIST }]
        }),
        setGettingStartedStepStatus: build.mutation<IActionResponse, IGettingStartedStepStatusRequest>({
            query: (arg) => ({
                url: `settings/gettingstarted/steps/${arg.id}`,
                method: 'PUT',
                body: { status: arg.status }
            }),
            invalidatesTags: [{ type: GETTING_STARTED_TYPE, id: LIST }]
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetGettingStartedQuery,
    useSetGettingStartedStepStatusMutation,
} = gettingStartedApi;
